import { Box, ButtonBase, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { avatar, profileBox, profileText, userName, userSignType } from './Header.sx';

export interface HeaderUser {
  fname?: string;
  lname?: string;
  mname?: string;
}

interface Props {
  user?: HeaderUser;
  sign?: string;
  onClick?: () => void;
}

const HeaderProfile = ({ user, sign, onClick }: Props) => {
  const { t } = useTranslation();

  const fullName = [user?.fname, user?.lname, user?.mname].filter(Boolean).join(' ');
  const initials = `${user?.fname?.[0] ?? ''}${user?.lname?.[0] ?? ''}`.toUpperCase();

  const signLabels: Record<string, string> = {
    first: t('homePage.firstSignature'),
    second: t('homePage.secondSignature'),
  };

  if (!fullName) return null;

  return (
    <ButtonBase sx={profileBox} onClick={onClick} disableRipple>
      <Box sx={avatar}>{initials}</Box>
      <Box sx={profileText}>
        <Typography sx={userName}>{fullName}</Typography>
        {sign && signLabels[sign] && <Typography sx={userSignType}>{signLabels[sign]}</Typography>}
      </Box>
    </ButtonBase>
  );
};

export default HeaderProfile;
